(function () {
  var params = new URLSearchParams(window.location.search);
  var serializedCards = params.get("acoustic_result_cards");
  var container = document.getElementById("acoustic-result-cards");
  if (!serializedCards || !container) return;

  container.className = "tw-hidden tw-w-full tw-max-w-container-xl tw-px-4 tw-py-8";
  container.setAttribute("aria-labelledby", "acoustic-result-cards-heading");
  var heading = document.createElement("div");
  heading.className = "tw-mb-6 tw-text-center";
  heading.innerHTML = '<h2 id="acoustic-result-cards-heading" class="tw-mb-2 tw-text-24 tw-font-bold tw-text-navy">Your Acoustic Solutions</h2><p class="tw-text-14 tw-text-grey-dark">Compare the recommended coverage levels with the quantities in your selected product mix.</p>';
  var resultGrid = document.createElement("div");
  resultGrid.className = "tw-grid tw-grid-cols-1 tw-gap-4 md:tw-grid-cols-2 xl:tw-grid-cols-4";
  resultGrid.setAttribute("data-acoustic-result-card-grid", "");
  container.appendChild(heading);
  container.appendChild(resultGrid);

  var cards;
  try {
    cards = JSON.parse(serializedCards);
  } catch (error) {
    return;
  }

  var allowedKeys = ["starter", "standard", "premium", "selection"];
  if (!Array.isArray(cards) || cards.length !== allowedKeys.length) return;
  if (cards.some(function (card, index) { return !card || card.key !== allowedKeys[index]; })) return;

  var grid = resultGrid;
  if (!grid) return;

  function appendTextElement(parent, tag, className, text) {
    var element = document.createElement(tag);
    element.className = className;
    element.textContent = text;
    parent.appendChild(element);
    return element;
  }

  function normalizedPath(path) {
    return (path || "/").replace(/\/+$/, "") || "/";
  }

  function productUrl(product) {
    if (!product || !product.url) return null;
    var url;
    try {
      url = new URL(product.url, window.location.origin);
    } catch (error) {
      return null;
    }
    url.searchParams.set("design_type", "Felt Right Design");
    url.searchParams.set("product_id", product.productId || "");
    url.searchParams.set("product_name", product.name || "");
    url.searchParams.set("quantity", String(Math.max(0, Math.ceil(Number(product.quantity) || 0))));
    url.searchParams.set("acoustic_result_cards", serializedCards);
    return url;
  }

  function productPath(product) {
    var url = productUrl(product);
    return url ? normalizedPath(url.pathname) : "";
  }

  var currentProductId = params.get("product_id") || "";
  var currentProductPath = normalizedPath(window.location.pathname);

  function isCurrentProduct(product) {
    if (currentProductId && product && product.productId) {
      return String(product.productId) === currentProductId;
    }
    return productPath(product) === currentProductPath;
  }

  var badgeClasses = {
    starter: "tw-bg-[#f3f1e9] tw-text-offblack",
    standard: "tw-bg-[#8196a9] tw-text-white",
    premium: "tw-bg-[#70a4d2] tw-text-white",
    selection: "tw-bg-navy tw-text-white",
  };

  cards.forEach(function (card) {
    var article = document.createElement("article");
    article.className = "tw-flex tw-flex-col tw-border tw-border-solid tw-border-navy tw-bg-white tw-p-4";
    article.setAttribute("data-acoustic-result-card", card.key);

    appendTextElement(
      article,
      "h3",
      "tw-mb-5 tw-w-fit tw-rounded-full tw-px-3 tw-py-1 tw-text-12 tw-font-bold " + badgeClasses[card.key],
      card.label || (card.key === "selection" ? "Your Selection" : card.key),
    );

    var products = Array.isArray(card.products) ? card.products : [];
    products.forEach(function (product, productIndex) {
      var row = document.createElement("section");
      row.className = "tw-flex tw-flex-col tw-items-center tw-text-center";
      row.setAttribute("data-acoustic-result-product", product.productId || "");
      if (productIndex > 0) row.className += " tw-mt-4 tw-border-t tw-border-solid tw-border-grey-light tw-pt-5";

      var quantity = Math.max(0, Math.ceil(Number(product.quantity) || 0));
      appendTextElement(row, "p", "tw-mb-2 tw-text-48 tw-font-bold tw-leading-none tw-text-navy", String(quantity));
      appendTextElement(row, "p", "tw-text-14 tw-leading-5 tw-text-offblack", product.name || "Selected product");

      if (quantity > 0 && !isCurrentProduct(product)) {
        var url = productUrl(product);
        if (url) {
          var link = appendTextElement(row, "a", "tw-mt-4 tw-inline-flex tw-min-w-[180px] tw-justify-center tw-rounded-full tw-bg-navy tw-px-6 tw-py-3 tw-text-14 tw-font-bold tw-text-white hover:tw-bg-opacity-90", "Shop Now");
          link.href = url.toString();
          link.setAttribute("aria-label", "Shop " + (product.name || "selected product") + " for " + (card.label || card.key));
        }
      }
      article.appendChild(row);
    });

    grid.appendChild(article);
  });

  document.body.classList.add("acoustic-result-cards-active");
  container.classList.remove("tw-hidden");
})();
